import { render } from "./RichTextCell.vue?vue&type=template&id=30672ff4&scoped=true"
import script from "./RichTextCell.vue?vue&type=script&lang=js"
export * from "./RichTextCell.vue?vue&type=script&lang=js"

import "./RichTextCell.vue?vue&type=style&index=0&id=30672ff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30672ff4"]])

export default __exports__